import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import Modal from '../../Modal/Modal';
import Heading from '../../Typography/Heading/Heading';
import { useTranslation } from 'react-i18next';
import styles from './QuickRaceModal.module.scss';
import cn from 'classnames';
import TabSubHeader from './TabSubHeader/TabSubHeader';
import QuickRaceRow from './QuickRaceRow/QuickRaceRow';
import { useAppSelector } from '../../../store/reducers';
import { isDarkMode } from '../../../store/selectors/settingSelectors';
import { useNavigate } from 'react-router-dom';
const QuickRaceModal = ({ onClose, quickRaceList }) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const darkMode = useAppSelector(isDarkMode);
    const data = [{ name: 'Upcoming' }, { name: 'Favorites' }];
    const handleSelectRace = (raceInfo) => {
        navigate(`/race/${raceInfo.id}`);
    };
    return (_jsxs(Modal, Object.assign({ className: cn(styles.modal), closeModal: onClose, background: true }, { children: [_jsx(Heading, { title: t('we_found_races_you_might_be_interested_in'), size: 1, fontWeight: 400, className: styles.title }), _jsx(TabSubHeader, { data: data, activeElement: 'Upcoming' }), _jsx("div", Object.assign({ className: cn(styles.content) }, { children: quickRaceList.map((it) => (_jsx(QuickRaceRow, { darkMode: darkMode, raceInfo: it, onClick: handleSelectRace }, it.id))) }))] })));
};
export default QuickRaceModal;
